<div class="val-modal">

  <button class="close-btn" (click)="dismiss()" aria-label="Close" *ngIf="modalType !== 'confirm'">
    <ion-icon name="close-outline"></ion-icon>
  </button>

  <div class="modal-top">

    <!-- mandatory -->
    <ng-container *ngIf="modalType === 'mandatory'">
      <div class="alert-circle danger">
        <ion-icon name="alert-circle-outline"></ion-icon>
      </div>
      <p class="modal-title">{{'self_pwa_text.validatation_missing_title' | translate}}</p>
      <h2 class="modal-headline">{{'self_pwa_text.validatation_guide_text' | translate}}</h2>
      <p class="modal-sub">{{ message }}</p>
    </ng-container>

    <!-- recommended -->
    <ng-container *ngIf="modalType === 'recommended'">
      <div class="alert-circle warn">
        <ion-icon name="information-circle-outline"></ion-icon>
      </div>
      <h2 class="modal-headline">{{'self_pwa_text.validatation_want_submit_inspection' | translate}}</h2>
      <p class="modal-sub">{{ message }}</p>
    </ng-container>

    <!-- confirm -->
    <ng-container *ngIf="modalType === 'confirm'">
      <div class="alert-circle success">
        <ion-icon name="checkmark-circle-outline"></ion-icon>
      </div>
      <p class="modal-title">{{'self_pwa_text.validatation_ready_submit' | translate}}</p>
      <h2 class="modal-headline">{{'self_pwa_text.validatation_everything_good' | translate}}</h2>
      <p class="modal-sub">{{ message }}</p>
    </ng-container>

  </div>

  <!-- zone list — mandatory only -->
  <div class="zone-section" *ngIf="modalType === 'mandatory' && mandatoryZones.length > 0"
    (touchmove)="$event.stopPropagation()" (wheel)="$event.stopPropagation()">
    <div class="zone-card" *ngFor="let zone of mandatoryZones; let i = index" (click)="navigateToZone(zone, i)">

      <div class="zone-arrow-wrap">
        <ion-icon name="return-down-forward-outline"></ion-icon>
      </div>

      <div class="zone-info">
        <p class="zone-name">
          {{ zone.zoneName.zoneName }}
        </p>
        <p class="zone-hint">{{'self_pwa_text.validatation_tap_open_section' | translate}}</p>
      </div>
    </div>
  </div>

  <!-- footer buttons -->
  <div class="modal-footer">
    <!-- recommended: Fill Now + Submit Without Filling -->
    <ng-container *ngIf="modalType === 'recommended'">
      <div class="btn-row">
        <ion-button fill="outline"
          class="nobackground show-fulltext h-48 font-size-16 t-c inter-medium letter-spacing-normal btn-half"
          (click)="onFillNow()">
          {{'self_pwa_text.validatation_fill_now' | translate}}
        </ion-button>
        <ion-button class="t-c commonbtn show-fulltext h-48 font-size-16 inter-medium letter-spacing-normal btn-half"
          (click)="onSubmitWithout()">
          {{'self_pwa_text.validatation_without_filling' | translate}}
        </ion-button>
      </div>
    </ng-container>

    <!-- confirm: Cancel + Confirm -->
    <ng-container *ngIf="modalType === 'confirm'">
      <div class="btn-row">
        <ion-button class="nobackground show-fulltext h-48 font-size-16 t-c inter-medium letter-spacing-normal btn-half"
          (click)="dismiss()">
          {{'self_pwa_text.validatation_cancel' | translate}}
        </ion-button>
        <ion-button class="t-c commonbtn show-fulltext h-48 font-size-16 inter-medium letter-spacing-normal btn-half"
          (click)="onSubmit()">
          {{'self_pwa_text.validatation_confirm' | translate}}
        </ion-button>
      </div>
    </ng-container>

  </div>

</div>